import { render } from "./GroupLearningEditorViewNew.vue?vue&type=template&id=392345b8&scoped=true"
import script from "./GroupLearningEditorViewNew.vue?vue&type=script&lang=js"
export * from "./GroupLearningEditorViewNew.vue?vue&type=script&lang=js"

import "./GroupLearningEditorViewNew.vue?vue&type=style&index=0&id=392345b8&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-392345b8"]])

export default __exports__